import React from 'react';
import {
    ExamQuestion,
    CustomSwitch,
    ExamApplicationStatus,
    CKText,
} from 'components';
import { IExamSessionDetails } from 'components/models';

const PracticalQuestionsTab = ({ examSessionDetails, finalized, applicantStatus }: IProps) => (examSessionDetails.practicalQuestions ? (
    <div>
        {examSessionDetails.practicalQuestions.map((question, i) => {
            const props = {
                question,
                practicalFactual: examSessionDetails.factualPracticalQuestionAnswers.find(factual => factual.questionId === question.id),
                num: i + 1,
            };

            return <ExamQuestion withoutResult key={`practical-questions_${i}`} {...props} />;
        })}
        {examSessionDetails.criteriaForRate && <div><h5>КРИТЕРИИ ОЦЕНКИ</h5><CKText text={examSessionDetails.criteriaForRate} /></div>}
        {finalized ? (
            <div className="mt-4">
                <CustomSwitch
                  name="examResult"
                  value={applicantStatus !== ExamApplicationStatus.NotPassed}
                  status={applicantStatus === ExamApplicationStatus.NotPassed ? 'reject' : 'accept'}
                  onClick={() => { }}
                  containerClassName="m-auto"
                />
                <b className="d-block text-center mt-2" style={{ fontWeight: 500 }}>
                    Практическая часть {`${applicantStatus === ExamApplicationStatus.Passed ? 'успешно сдана' : 'не сдана'}`}
                </b>
            </div>
        ) : null}
    </div>
) : null);

export default PracticalQuestionsTab;

interface IProps {
    examSessionDetails: IExamSessionDetails;
    applicantStatus: ExamApplicationStatus;
    finalized: boolean;
}
